import Config  from '../provider/config'
import Modules from '../provider/modules'

import { hasProp } from 'vessel/utils'

function normalize(module, data, options) {
  let value = data

  if (value == null || !options)
    return []

  if (!Array.isArray(value))
    value = [value]

  value = value.map(val => {
    if (hasProp(val, options.values))
      val = options.values[val]

    return val
  })

  return value
}

function prefix(name, prefix) {
  let sep    = name.includes('-') ? '' : '-'
  let string = name

  if (string.endsWith('-default'))
    string = string.replace(/-default$/, '')

  if (string == 'default' || `${prefix}`.endsWith(`-${string}`))
    string = ''

  if (!sep)
    sep = prefix && prefix.length > 1 ? '-' : ''

  if (!string.length || string.startsWith('-'))
    sep = ''

  if (prefix && prefix.length)
    string = `${prefix}${sep}${string}`

  return string
}

export default function generate(screen, state, module, value) {
  const options = Modules[module]
  const classes = {}

  if (!options)
    return {}

  const drops = ['all', 'normal']
  const parts = [screen, state].filter(part => !drops.includes(part))
  const names = normalize(module, value, options)

  names.forEach(val => {
    if (val != null && val != undefined) {
      const name = prefix(`${val}`, options.prefix)
      const key  = [...parts, name].join(Config.options.separator)

      classes[key] = true
    }
  })

  return classes
}
